import { AfterViewInit, Component, ElementRef, Renderer2 } from '@angular/core';
import { formatCPFOrCNPJ } from 'src/app/helpers/utils/cpf-cnpj.util';
import { CarbonCredit } from 'src/app/shared/interfaces/carbon-credit';
import { AppModalOverlayRef } from 'src/app/shared/services/app-modal.service';

export interface DetailTableColumn {
  label: string;
  value?: string | number | null | undefined;
  isLink?: boolean;
  flex?: number;
}

export interface DetailTableSection {
  columns: DetailTableColumn[];
}

@Component({
  standalone: false,
  selector: 'app-modal-carbon-credit-detail',
  templateUrl: './modal-carbon-credit-detail.component.html',
  styleUrls: ['./modal-carbon-credit-detail.component.scss'],
})
export class ModalCarbonCreditDetailComponent implements AfterViewInit {
  readonly title = 'Detalhes do Crédito de Carbono';
  sections: DetailTableSection[] = [];

  constructor(
    public dialogRef: AppModalOverlayRef<ModalCarbonCreditDetailComponent>,
    private el: ElementRef,
    private renderer: Renderer2,
  ) {
    const carbon: CarbonCredit = this.dialogRef?.data?.carbon ?? this.dialogRef?.data ?? ({} as CarbonCredit);
    this.sections = this.buildSections(carbon);
  }

  close(): void {
    this.dialogRef.close();
  }

  ngAfterViewInit(): void {
    this.renderer.setStyle(this.el.nativeElement, 'display', 'contents');
  }

  private buildSections(carbon: CarbonCredit): DetailTableSection[] {
    return [
      {
        columns: [
          { label: 'Tipo IF', value: carbon.financialInstrumentTypeCode, flex: 74 },
          { label: 'Data de emissão', value: carbon.issueDate, flex: 105 },
          { label: 'Emitida', value: carbon.creditInitialQuantity, flex: 78 },
          { label: 'Atual', value: carbon.creditQuantity, flex: 64 },
          { label: 'Descrição adicional', value: carbon.observationText, isLink: this.isUrl(carbon.observationText), flex: 182 },
          { label: 'Início da safra (Vintage)', value: carbon.vintageStart, flex: 124 },
          { label: 'Final da safra (Vintage)', value: carbon.vintageEnd, flex: 124 },
        ],
      },
      {
        columns: [
          { label: 'Comitente', value: this.formatComitente(carbon.comitenteDocumentNumber), flex: 182 },
          { label: 'Nome do projeto', value: carbon.projectName, flex: 90 },
          { label: 'Serial Range/ Credts ID', value: carbon.serialCode, flex: 315 },
          { label: 'Link do projeto na certificadora', value: carbon.projectLink, isLink: this.isUrl(carbon.projectLink), flex: 136 },
          { label: 'Nome da Certificadora', value: carbon.certifierDescription, flex: 117 },
        ],
      },
    ];
  }

  private formatComitente(value?: string | null): string {
    return value ? formatCPFOrCNPJ(value) : '';
  }

  private isUrl(value: string | null | undefined): boolean {
    if (!value) return false;
    return /^https?:\/\//i.test(value.trim());
  }
}
